/**
 * forms
 */

import $ from 'jquery';

import './form-validator';
import './members';

// Import Select2 for form selects
import 'select2';
import 'select2/dist/css/select2.css';

// Module dependencies
import 'protons';

// Module styles
import './_forms.scss';
import './_ckeditor.scss';
import './_inline-entity-form.scss';
import './_members.scss';
import './_select2.scss';

// Module template
import './_forms.twig';

// Configure which select elements use Select2 plugin

// Single select
$('#edit-field-area').select2({
  theme: 'bootstrap4',
  width: '100%',
  placeholder: Drupal.t('None'),
});
// Multiselect
// Remove Drupal's default option
$("select[multiple] option[value='_none']").each(() => {
  $(this).remove();
});
$('select[multiple]').select2({
  theme: 'bootstrap4',
  width: '100%',
  placeholder: {
    id: '_none',
    text: Drupal.t('None'),
  },
});

export const name = 'forms';

export const defaults = {
  dummyClass: 'js-forms-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { forms = {} }) {
  // Find our component within the DOM
  const $forms = $('.forms', $context);
  // Bail if component does not exist
  if (!$forms.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = Object.assign(defaults, forms);
  // An example of what could be done with this component
  $forms.addClass(settings.dummyClass);
}

export default enable;
